import React, {useState} from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import supabase from '../supabase/supabase';

const {FiArrowRight, FiLock, FiMail, FiMusic} = FiIcons;

function getAuthErrorMessage(error) {
  const message = error?.message || '';

  if (/invalid login credentials/i.test(message)) {
    return 'Wrong email or password.';
  }

  if (/email not confirmed/i.test(message)) {
    return 'Wrong email or password.';
  }

  if (/user already registered/i.test(message)) {
    return 'Wrong email or password.';
  }

  return 'Wrong email or password.';
}

function AuthScreen() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  const submit = async (event) => {
    event.preventDefault();
    setBusy(true);
    setError('');

    try {
      const result = await supabase.auth.signInWithPassword({email, password});

      if (result.error) {
        throw result.error;
      }
    } catch (authError) {
      setError(getAuthErrorMessage(authError));
    } finally {
      setBusy(false);
    }
  };

  return (
    <main className="auth-screen">
      <section className="auth-card">
        <div className="auth-brand-mark">
          <SafeIcon icon={FiMusic} />
        </div>
        <span className="eyebrow">Angels Music Productions</span>
        <h1>Event Backstage</h1>
        <p className="auth-intro">
          Sign in to manage event details, production plans, and client updates.
        </p>
        <form className="auth-form" onSubmit={submit}>
          <label>
            <span>Email address</span>
            <span className="auth-input">
              <SafeIcon icon={FiMail} />
              <input
                autoComplete="email"
                type="email"
                value={email}
                onChange={(event) => setEmail(event.target.value)}
                required
              />
            </span>
          </label>
          <label>
            <span>Password</span>
            <span className="auth-input">
              <SafeIcon icon={FiLock} />
              <input
                autoComplete="current-password"
                type="password"
                minLength="8"
                value={password}
                onChange={(event) => setPassword(event.target.value)}
                required
              />
            </span>
          </label>
          {error && <p className="auth-error" role="alert">{error}</p>}
          <button className="button primary auth-submit" disabled={busy}>
            {busy ? 'Please wait…' : 'Sign in'}
            <SafeIcon icon={FiArrowRight} />
          </button>
        </form>
        <p className="auth-security-note">
          Use an app account in Supabase Authentication. Supabase dashboard login details are separate.
          Event records are separated by the signed-in account.
        </p>
      </section>
    </main>
  );
}

export default AuthScreen;